/**
 * Copyright 2021 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
export const capitalize = (value?: string | null): string =>
  value ? value.charAt(0).toUpperCase() + value.slice(1).toLowerCase() : '';
